var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVilnaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 50,
    viewBox: "0 0 143 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7109 41.7894L13.9273 26.0058L22.9023 49.0623L29.7109 41.7894Z",
    fill: "url(#paint0_linear_2689_21467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34461 0.937561L24.9136 18.7328L6.80884 14.2453L6.34461 0.937561Z",
    fill: "url(#paint1_linear_2689_21467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7598 18.5782L33.4253 24.3036L21.8197 33.8976L13.9279 26.0058L24.7598 18.5782Z",
    fill: "url(#paint2_linear_2689_21467)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0326 23.3749L38.377 17.959L24.7597 18.5779L32.0326 23.3749Z",
    fill: "url(#paint3_linear_2689_21467)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7593 18.5783L30.4847 12.8528L42.0903 17.8046L24.7593 18.5783Z",
    fill: "#35BDF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00031662 10.6862L24.7583 18.578L13.9264 26.0056L-0.00031662 10.6862Z",
    fill: "url(#paint4_linear_2689_21467)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0698 41.3252L13.9267 26.0058L15.3193 43.0273L12.0698 41.3252Z",
    fill: "url(#paint5_linear_2689_21467)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.496 45.6575L13.939 26.0023L20.7367 43.3367L15.496 45.6575Z",
    fill: "url(#paint6_linear_2689_21467)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1502 16.5661L42.0903 17.8041L38.3765 17.9588L39.1502 16.5661Z",
    fill: "#FFE600"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4503 19.3561L49.841 30.6297L46.2742 19.3561H43.0684L47.9303 34.2178H51.7518L56.6562 19.3561H53.4503Z",
    fill: "#1A1C1E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7053 17.1481C58.6438 17.1481 57.8158 17.8912 57.8158 18.9315C57.8158 19.9718 58.6438 20.7361 59.7053 20.7361C60.8093 20.7361 61.5949 19.9718 61.5949 18.9315C61.5949 17.8912 60.8093 17.1481 59.7053 17.1481ZM58.1767 34.2178H61.2127V22.5407H58.1767V34.2178Z",
    fill: "#1A1C1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6715 34.2178H66.7076V17.8699H63.6715V34.2178Z",
    fill: "#1A1C1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7904 22.286C74.1769 22.286 73.0092 22.9441 72.1599 24.1331V22.5407H69.1239V34.2178H72.1599V28.082C72.1599 26.1712 73.0729 25.1734 74.7926 25.1734C76.4061 25.1734 76.9794 26.0226 76.9794 27.5512V34.2178H80.0154V26.8931C80.0154 24.0269 78.4231 22.286 75.7904 22.286Z",
    fill: "#1A1C1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.057 22.5407V24.1755C90.2502 23.0503 89.0188 22.286 87.3628 22.286C84.3692 22.286 82.0551 24.77 82.0551 28.3793C82.0551 31.9673 84.3268 34.4725 87.384 34.4725C89.0188 34.4725 90.229 33.7507 91.0358 32.6467V34.2178H94.0718L94.093 22.5407H91.057ZM88.0634 31.5851C86.3862 31.5851 85.1123 30.3113 85.1123 28.3793C85.1123 26.4685 86.3649 25.1734 88.0634 25.1734C89.7619 25.1734 91.057 26.4685 91.057 28.3793C91.057 30.3113 89.7619 31.5851 88.0634 31.5851Z",
    fill: "#1A1C1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.965 34.4938C107.616 34.4938 110.398 32.2008 111.205 28.9737H107.34C106.746 30.2688 105.536 31.0544 103.965 31.0544C101.502 31.0544 99.9096 29.271 99.9096 26.7869C99.9096 24.3029 101.502 22.5195 103.965 22.5195C105.536 22.5195 106.746 23.3051 107.34 24.6001H111.205C110.398 21.373 107.616 19.0801 103.965 19.0801C99.5063 19.0801 96.2579 22.4134 96.2579 26.7869C96.2579 31.1605 99.5063 34.4938 103.965 34.4938Z",
    fill: "#1A1C1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.675 34.2178H126.091L122.185 28.719C124.011 28.1245 125.157 26.702 125.157 24.3241C125.157 21.2244 123.204 19.3561 120.062 19.3561H113.438V34.2178H117.047V29.0586H118.172L121.675 34.2178ZM121.505 24.3666C121.505 25.3857 120.911 25.8952 119.658 25.8952H117.047V22.7955H119.658C120.868 22.7955 121.505 23.3263 121.505 24.3666Z",
    fill: "#1A1C1E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.902 19.3561L135.505 24.4515L132.108 19.3561H128.011V34.2178H131.62V24.4091L135.335 30.0777H135.675L139.39 24.4091V34.2178H143V19.3561H138.902Z",
    fill: "#1A1C1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2689_21467",
    x1: 21.8191,
    y1: 26.0058,
    x2: 21.8191,
    y2: 49.0623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2689_21467",
    x1: 15.6291,
    y1: 0.937561,
    x2: 22.5925,
    y2: 17.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30B7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45D0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2689_21467",
    x1: 25.6882,
    y1: 15.0191,
    x2: 18.5701,
    y2: 40.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132906,
    stopColor: "#45D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#2CB3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2689_21467",
    x1: 32.3023,
    y1: 18.067,
    x2: 31.3234,
    y2: 22.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732198,
    stopColor: "#30B8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89363,
    stopColor: "#40CAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2689_21467",
    x1: -0.000316526,
    y1: 12.2336,
    x2: 20.4255,
    y2: 32.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728061,
    stopColor: "#FFD910"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2689_21467",
    x1: 13.6946,
    y1: 26.0058,
    x2: 13.6946,
    y2: 43.0273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2689_21467",
    x1: 11.5818,
    y1: 26.8764,
    x2: 18.1779,
    y2: 44.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38C1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#44CFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilnaLogo);
export default __webpack_public_path__ + "static/media/vilna-logo.e88e2f9b0fe15623102005eefbf32dfb.svg";
export { ForwardRef as ReactComponent };